import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useI18n } from "../../../../contexts";
const FormServiceGroupFieldName = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsx(Form.Item, {
        label: __("Name"),
        name: "name",
        required: true,
        style: {
            marginBottom: 12
        },
        rules: [
            {
                required: true,
                message: __("Please enter a name!")
            }
        ],
        children: /*#__PURE__*/ _jsx(Input, {
            autoFocus: true,
            onKeyDown: (e)=>/**
                     * `rc-tabs` defines an `onKeyDown` event which causes issues with enter and spaces and avoids
                     * input fields in the tab to get filled correctly.
                     *
                     * @see https://git.io/JUZZO
                     */ e.stopPropagation()
        })
    });
};
export { FormServiceGroupFieldName };
